module.exports = __webpack_public_path__ + "img/1020.c291747c.png";